import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login/login.component';
import { IonicModule } from '@ionic/angular';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SetNewPasswordComponent } from './set-new-password/set-new-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ElcmCondidateFromComponent } from './elcm-condidate-from/elcm-condidate-from.component';
import { WelcomeMessageComponent } from './welcome-message/welcome-message.component';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { AutoLoginComponent } from '../auto-login/auto-login.component';
import { LoginwithOTPComponent } from '../hradmin/loginwith-otp/loginwith-otp.component';
import { EmployeeSatisfactionSurveyComponent } from './employee-satisfaction-survey/employee-satisfaction-survey.component';
@NgModule({
  declarations: [
    LoginComponent,
    LoginwithOTPComponent,
    PageNotFoundComponent,
    ForgotPasswordComponent,
    SetNewPasswordComponent,
    ResetPasswordComponent,
    ElcmCondidateFromComponent,
    EmployeeSatisfactionSurveyComponent,
    WelcomeMessageComponent,
    AutoLoginComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    IonicModule,
    FormsModule,ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatIcon
  ]
})
export class LoginModule { }
